import { Badge } from '../Badge/Badge'
import type { CodeBadgeProps } from './CodeBadge.types'

export function CodeBadge({ code }: CodeBadgeProps) {
  if (!code) return null
  return <Badge color="grey">{code}</Badge>
}
